// @owners { team: patients }
import { NavigationService } from '@alto/navigation';

export const useIsInCheckout = () => {
  const currentRoute = NavigationService.getCurrentRouteName();
  return currentRoute && ['RouteCheckout', 'RouteEditOrder', '/checkout'].includes(currentRoute);
};
